import { privateClient } from "@/api/privateClient";
import { SUPER_ADMIN_ENDPOINTS } from "../../../endpoint";
import type { ChallengesSection, ChallengePair } from "../types";

export const getChallenges = async (): Promise<ChallengesSection> => {
  const { data } = await privateClient.get(SUPER_ADMIN_ENDPOINTS.CMS.CHALLENGES.GET);
  return data.section;
};

export const updateChallengesSection = async (
  payload: Pick<ChallengesSection, "headingLine1" | "headingLine2" | "subtitle">
): Promise<ChallengesSection> => {
  const { data } = await privateClient.put(SUPER_ADMIN_ENDPOINTS.CMS.CHALLENGES.UPDATE, payload);
  return data.section ?? data;
};

export const addPair = async (payload: Omit<ChallengePair, "id">): Promise<ChallengePair> => {
  const { data } = await privateClient.post(SUPER_ADMIN_ENDPOINTS.CMS.CHALLENGES.ADD_PAIR, payload);
  return data.pair ?? data;
};

export const updatePair = async (pairId: number, payload: Omit<ChallengePair, "id">): Promise<ChallengePair> => {
  const { data } = await privateClient.put(SUPER_ADMIN_ENDPOINTS.CMS.CHALLENGES.UPDATE_PAIR(pairId), payload);
  return data.pair ?? data;
};

export const removePair = async (pairId: number): Promise<number> => {
  await privateClient.delete(SUPER_ADMIN_ENDPOINTS.CMS.CHALLENGES.REMOVE_PAIR(pairId));
  return pairId;
};